import styled from 'styled-components'

export const SidebarTodoList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-gap: 20px;
    align-items: center;
    justify-content: center;
`